module.exports = __webpack_public_path__ + "img/Alice.ec097a62.jpeg";